<template>
	<main id="liste" v-cloak>
		<HeaderTab :title="$t('compta.title_page')" :swiper_tabs="swiper_tabs" :accounting_plan="accounting_plan"/>

		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<div>
							<LoadingSpinner class="col-12" v-if="!tab_loaded" />
							<router-view v-if="tab_loaded" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>


<script type="text/javascript">
	import Navigation from "@/mixins/Navigation.js";
	import Accounting from "@/mixins/Accounting.js";

	export default {
		name: "AccountingFiche",
		mixins: [Navigation, Accounting],
		data () {
			return {
				param_tab: '',
				actual_tab: 'AccountingInformations',
				tab_loaded: false,
				accounting_plan: null
			}
		},

		mounted() {
			this.param_tab = this.$route.params.actual_tab
			this.init_component()
		},

		methods: {
			async init_component() {

				this.tab_loaded = false
				this.accounting_plan = null
				if(this.$route.params.accountingplan_id) {
					const accounting_plan = await this.loadAccountingPlan(this.$route.params.accountingplan_id)
					if(!accounting_plan) {
						this.$router.push({ name: 'accountingListe' })
					} else {
						this.tab_loaded = true
						this.accounting_plan = accounting_plan
						document.title = this.accounting_plan ? this.accounting_plan.accountingplan_label : "Groomy"
					}
				} else {
					this.$router.push({ name: 'accountingListe' })
				}
			}
		},
		computed: {
			swiper_tabs() {
				return [{
					id: 'info',
					label: 'global.informations',
					active: false,
					href: 'AccountingInformations'
				}, {
					id: 'm_fact',
					label: 'compta.model',
					active: false,
					href: 'AccountingModel',
					hidden: !this.hasFacturationAccess
				},
				// {
				// 	id: 'm_devis',
				// 	label: 'compta.model_devis',
				// 	active: false
				// },
				// {
				// 	id: 'm_avoir',
				// 	label: 'compta.model_avoir',
				// 	active: false
				// },
				{
					id: 'c_compta',
					label: 'compta.comptes_comptables',
					href : 'AccountingFicheAccountingAccount',
					active: false
				},/*{
					id: 'c_compta_payment',
					label: 'compta.comptes_comptables_payment',
					href : 'AccountingFicheAccountingPaymentAccount',
					active: false
				}, */{
					id: 'article',
					label: 'compta.articles',
					href : 'AccountingFicheArticles',
					active: false,
					hidden: !this.hasFacturationAccess
				}, {
					id: 'acte_type_article',
					label: 'compta.acte_type_article',
					href : 'AccountingFicheActesTypeArticles',
					active: false,
					hidden: !this.hasFacturationAccess
				}, {
					id: 'pension',
					label: 'compta.pensions',
					href : 'AccountingFichePension',
					active: false,
					hidden: !this.hasFacturationAccess
				}, {
					id: 'remise_cheque',
					label: 'compta.remise_cheque',
					href : 'AccountingRemiseChequeConfig',
					active: false
				}, {
					id: 'export_config',
					label: 'compta.export_config',
					href : 'ExportConfig',
					active: false
				}, {
					id: 'fec',
					label: 'compta.fec.tab',
					href : 'AccountingFec',
					active: false,
					hidden: !this.hasFacturationAccess
				}, {
					id: 'accounting_config',
					label: 'compta.accounting_config',
					href : 'AccountingConfig',
					active: false
				}, {
					id: 'e_invoicing',
					label: 'compta.e_invoicing',
					href : 'AccountingEInvoicing',
					active: false,
					hidden: !this.hasEInvoicing
				}, {
					id: 'superpdp',
					label: 'compta.superpdp.tab',
					href : 'AccountingSuperPDP',
					active: false,
					hidden: !this.hasSuperPDP
				}]
			},

			hasFacturationAccess() {
				return this.$store.state.userAccess.hasFacturationAccess
			},
			// vérifie si la compte est belge et si l'utilisateur est l'admin de sa licence
			hasEInvoicing() {
				return this.accounting_plan && [21,290].includes(this.accounting_plan.tiers.tiers_country) && this.$store.state.userAccess.hasLicenceAdminAccess
			},
			// vérifie que la compta est française, que l'intégration SUPER PDP est activée pour l'environnement, que l'utilisateur a accès à la facturation ou aux factures fournisseurs OCR et qu'il est l'admin de sa licence
			hasSuperPDP() {
				return this.accounting_plan && this.accounting_plan.tiers.tiers_country == 75 && this.accounting_plan.accountingplan_superpdp_enabled && (this.hasFacturationAccess || this.$store.state.userAccess.hasInvoiceSupplierOCR) && this.$store.state.userAccess.hasLicenceAdminAccess
			}
		},
		components: {
			HeaderTab: () => import('@/components/HeaderTab'),
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}
</script>
